import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import { ChunkErrorBoundary } from "@/components/ChunkErrorBoundary";

const AboutSection = lazy(() => import("@/components/AboutSection"));
const TechStackSection = lazy(() => import("@/components/TechStackSection"));
const ProjectsSection = lazy(() => import("@/components/ProjectsSection"));
const ExperienceSection = lazy(() => import("@/components/ExperienceSection"));
const ContactSection = lazy(() => import("@/components/ContactSection"));

const Index = () => {
  return (
    <main>
      <a href="#about" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[200] focus:bg-primary focus:text-primary-foreground focus:px-4 focus:py-2 focus:rounded-lg">
        Skip to content
      </a>
      <Navbar />
      <HeroSection />
      <ChunkErrorBoundary>
        <Suspense fallback={null}>
          <AboutSection />
          <TechStackSection />
          <ExperienceSection />
          <ProjectsSection />
          <ContactSection />
          <footer className="py-12 md:py-16 text-center text-sm text-muted-foreground border-t border-border/50">
            <p>&copy; 2026 Rohit</p>
          </footer>
        </Suspense>
      </ChunkErrorBoundary>
    </main>
  );
};

export default Index;
